import data from '@assets/json/i18n.json'
import LocalizedStrings from 'react-localization'

export type I18nKey = keyof (typeof data['en'])

export const i18n = new LocalizedStrings(data)
